'use client';

import { GlobeHemisphereWest, Lock, Question } from 'phosphor-icons';
import { pluralize } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Avatar } from '../../atoms/Avatar';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../atoms/Tooltip/TooltipRadix';
import type { ProductListInfoProps } from './ProductListInfo.types';

export const ProductListInfo = ({
  className = '',
  count,
  visibility,
  isDefault,
  userName,
  microcopy,
}: ProductListInfoProps) => {
  const assetsText = pluralize(
    'assetsLabel',
    {
      assetsLabelOne: microcopy.assetsLabelOne,
      assetsLabelOther: microcopy.assetsLabelOther,
    },
    count
  );
  const visibilityLabel =
    visibility === 'private' ? microcopy.privateLabel : microcopy.publicLabel;
  const VisibilityIcon = visibility === 'private' ? Lock : GlobeHemisphereWest;

  return (
    <div className={c('flex flex-col gap-2', className)}>
      <div className="flex items-center gap-2">
        <span className="body-small text-grey-700">{assetsText}</span>
        <span className="text-grey-700">•</span>
        <div className="flex items-center gap-1 text-grey-700">
          <VisibilityIcon size={16} weight="fill" aria-hidden="true" />
          <span className="body-small">{visibilityLabel}</span>
        </div>
        {isDefault && (
          <>
            <span className="text-grey-700">•</span>
            <div className="flex items-center gap-1 text-grey-700">
              <span className="body-small">{microcopy.defaultLabel}</span>
              <Tooltip>
                <TooltipTrigger aria-label={microcopy.defaultHelp}>
                  <Question
                    size={16}
                    weight="fill"
                    className="hidden text-grey-500 md:inline-flex"
                    aria-hidden="true"
                  />
                </TooltipTrigger>
                <TooltipContent>
                  <p className="text-sm text-grey-900">
                    {microcopy.defaultHelp}
                  </p>
                </TooltipContent>
              </Tooltip>
            </div>
          </>
        )}
      </div>
      {userName && (
        <div className="flex items-center gap-2">
          <Avatar
            userName={userName}
            size={24}
            className="shrink-0"
            textClassName="text-white text-[10px]"
          />
          <span className="body-small text-grey-700">{userName}</span>
        </div>
      )}
    </div>
  );
};

ProductListInfo.displayName = 'ProductListInfo';
